<template>
  <div>
    <el-form ref="form" :model="indexData" label-position="top" :rules="rules">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="저장소명" label-width="120px" prop="dataindexName">
            <el-input v-model="indexData.dataindexName" ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="생성 주기" label-width="120px">
            <el-radio-group v-model="indexData.creationInterval">
              <el-radio v-model="indexData.creationInterval" label="D">1일</el-radio>
              <el-radio v-model="indexData.creationInterval" label="H">1시간</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-form-item label="저장소 패턴" label-width="120px" prop="dataindexId">
          <span slot="label">
            <span class="mr-r4">저장소 패턴</span>
            <el-popover placement="bottom" width="500" trigger="hover" :offset="40">
              <span class="text"> - 저장소 패턴 입력 시 고유 패턴만 입력 하세요 <br/> - <em>log</em> 와 <em>시간 (YYYY.DD.MM)</em>은 자동으로 작성됩니다.</span>
              <span slot="reference"><i class="fas fa-info-circle" style="cursor: pointer"></i></span>
            </el-popover>
          </span>
          <el-input v-model="indexData.dataindexId"></el-input>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="보관 기한" label-width="120px" prop="retentionAge">
          <el-input v-model="indexData.retentionAge" type="Number">
            <span class="el-input__icon" slot="suffix">{{"(일)"}}</span>
          </el-input>
        </el-form-item>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import { isEmpty } from 'lodash';
import indexAPI from '@/api/settings/log/lms-dataindex-setting';

export default {
  name: 'WIndexBasicSetting',
  props: {
    indexData: {
      type: Object,
    },
  },
  data() {
    const validationDataindexId = (rule, value, callback) => {
      const pattern = new RegExp('[-=\'`,./"~!@#$%^&*()+|<>?:{}ㄱ-ㅎ가-힣]');
      const isCheck = pattern.test(value);
      let isExist = false;
      const params = {
        params: {
          dataindexId: value,
        },
      };
      indexAPI.checkDataindexId(params).then((response) => {
        if (response.data.success && !response.data.data) {
          isExist = true;
        }
        if (isCheck) {
          callback(new Error('영문/숫자 조합으로 작성하세요'));
        } else if (isEmpty(value)) {
          callback(new Error('필수 입력 정보입니다.'));
        } else if (isExist) {
          callback(new Error('이미 존재하는 저장소 패턴입니다.'));
        } else {
          callback();
        }
      }).catch((e) => {
        callback(new Error('저장소 패턴 검수에 실패했습니다.'));
        throw new Error(e);
      });
    };
    const validateNumber = (rule, value, callback) => {
      if (isEmpty(value)) {
        callback(new Error('보관일을 입력하세요'));
      } else if (value <= 179) {
        callback(new Error('보관일을 180일 이상으로 설정하세요'));
      }
      callback();
    };
    return {
      rules: {
        dataindexName: [
          { required: true, message: '필수 입력 정보입니다.', trigger: 'blur' },
        ],
        dataindexId: [
          { required: true, validator: validationDataindexId, trigger: 'blur' },
        ],
        retentionAge: [
          { required: true, validator: validateNumber, trigger: 'blur' },
        ],
      },
    };
  },
  methods: {
    nextStep() {
      this.$refs.form.validate().then((success) => {
        if (success) {
          this.$emit('increaseActiveStep');
        }
      }).catch(() => {});
    },
    resetField() {
      this.$refs.form.resetFields();
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/settings/log-analysis/Collect/LogIndex/components/IndexBasicSetting.vue